export default __webpack_public_path__ + "static/media/placeholder_business03-fr-mobile.8c4d936a.png";